import { createContext, useContext, useMemo, type ReactNode } from 'react'
import type { EliteOnboardingStatusResponse } from '../../types/misc.types'
import { getEliteBuyCtaEventExtras, type EliteEventExtras } from '../../utils/eliteEventExtras'

/**
 * Screen-level buy-CTA analytics extras (`amount` + `cta_name`).
 *
 * Each Elite screen owns its advisory query and provides its own status here, so
 * leaf events (FAQ, back/close, pointers, Upgrade CTA) can read the price/plan-ids
 * without the data being drilled through every parent. Default is `{}` so events
 * outside a provider (or before data loads) stay safe and just omit the fields.
 */
const EliteBuyCtaExtrasContext = createContext<EliteEventExtras>({})

export function EliteBuyCtaExtrasProvider({
  status,
  children
}: {
  status?: EliteOnboardingStatusResponse | null
  children: ReactNode
}) {
  const extras = useMemo(() => getEliteBuyCtaEventExtras(status), [status])
  return <EliteBuyCtaExtrasContext.Provider value={extras}>{children}</EliteBuyCtaExtrasContext.Provider>
}

export function useEliteBuyCtaExtras(): EliteEventExtras {
  return useContext(EliteBuyCtaExtrasContext)
}
